import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h2 className="text-2xl font-bold text-white mb-6">おかやま鍼灸院</h2>
            <p className="text-white/80 mb-6 text-sm leading-relaxed">
              岡山市北区で2000年より地域の皆様の健康をサポート。<strong>一人ひとりに寄り添うオーダーメイド鍼灸治療</strong>で、<strong>痛みの根本改善</strong>から日々の疲れまで幅広く対応いたします。
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-line-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white">診療案内</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-white/70 hover:text-white transition-colors">施術内容</Link></li>
              <li><Link to="/about" className="text-white/70 hover:text-white transition-colors">料金表</Link></li>
              <li><Link to="/booking" className="text-white/70 hover:text-white transition-colors">初めての方へ</Link></li>
              <li><Link to="/" className="text-white/70 hover:text-white transition-colors">よくある質問</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">医院情報</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-white/70 hover:text-white transition-colors">アクセス</Link></li>
              <li><Link to="/about" className="text-white/70 hover:text-white transition-colors">営業時間</Link></li>
              <li><Link to="/" className="text-white/70 hover:text-white transition-colors">スタッフ紹介</Link></li>
              <li><Link to="/blog" className="text-white/70 hover:text-white transition-colors">ブログ</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">お問い合わせ</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/booking" className="text-white/70 hover:text-white transition-colors">ご予約</Link></li>
              <li><a href="tel:086-012-3456" className="text-white/70 hover:text-white transition-colors">電話予約</a></li>
              <li><Link to="/recruit" className="text-white/70 hover:text-white transition-colors">求人情報</Link></li>
              <li><a href="#contact" className="text-white/70 hover:text-white transition-colors cursor-pointer">お問い合わせ</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
          <p className="text-white/60">© 2025 おかやま鍼灸院. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/60 hover:text-white transition-colors">プライバシーポリシー</a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
